/** Kurumsal marka sabitleri — tek kaynak */
export const BRAND = {
  name: 'Luminary Business Solutions',
  legalName: 'Luminary Yazılım ve Danışmanlık San. Tic. Ltd. Şti.',
  shortName: 'Luminary',
  foundedYear: 2008,
  siteUrl: 'https://www.luminarybs.com',
  ogImage: '/logo.png',
  email: 'info@luminarybs.com',
} as const;

export const PARTNER_NAMES = {
  boyumIt: 'Boyum-IT',
  dnasoft: 'DNAsoft',
  sap: 'SAP B1',
  promesIot: 'ProMES & IoT',
} as const;
